interface ScriptConstructor {
  new (): Script;
  readonly pathname: RegExp;
}

export abstract class Script {
  static readonly registry: ScriptConstructor[] = [];
  abstract script(): void;
}

window.addEventListener('load', () => {
  const ctor = Script.registry.find(
    script => script.pathname.test(location.pathname));
  if (!ctor)
    return;
  new ctor().script();
});
